import React from "react";
import { useApp } from "context";
import { Constants } from "utils";

type Props = {
  serviceId: number;
};

export const ServiceIcon = (props: Props) => {
  const { theme } = useApp();

  const Icon = Constants.serviceMap.get(props.serviceId)?.iconComponent;

  return Icon ? (
    <Icon fill={theme.palette.font.color} className="service-icon" />
  ) : (
    <></>
  );
};
